import React, { FC } from 'react'

import styled from 'styled-components'

import { ArtistBalanceItemProps } from '.'

type ArtistBalanceItemAmountProps = Pick<
  ArtistBalanceItemProps,
  'amount' | 'positive' | 'bold'
>
const Container = styled.div`
  display: flex;
  width: 80px;
  justify-content: flex-end;
  align-items: center;
  gap: 4px;
`
const Text = styled.span<{ $bold?: boolean; $positive?: boolean }>`
  color: ${({ theme, $positive }) =>
    $positive ? theme.color.brandGreen : theme.color.darkGrey};
  font-family: 'Segoe UI';
  font-size: 14px;
  font-style: normal;
  font-weight: ${({ $bold }) => ($bold ? '600' : 'normal')};
  line-height: 150%;
`

export const ArtistBalanceItemAmount: FC<ArtistBalanceItemAmountProps> = (
  props,
) => {
  const { bold, amount, positive } = props
  return (
    <Container>
      <Text $positive={positive} $bold={bold}>
        {amount}
      </Text>
    </Container>
  )
}
